<template>
  <div class="treatment-plan-item__table__row">
    <button
      class="treatment-plan-item__table__row__button-group"
      type="button"
      v-on:click.stop="onEditTemplate(template)"
    >
      <span class="treatment-plan-item__table__row__name row-name">{{ template.name }}</span>
      <span v-if="template.hasTrashed">У данного шаблона были удалены услуги</span>
    </button>
    <button
      class="treatment-plan-item__table__cell treatment-plan-item__table__row__edit"
      type="button"
      title="Редактировать шаблон"
      v-on:click.stop="onEditTemplate(template)"
    />
    <button
      class="treatment-plan-item__table__row__delete"
      type="button"
      title="Удалить шаблон"
      v-on:click.stop="onShowDeleteDialog(template.id)"
    />
  </div>
</template>

<script>

/**
 * @description Название события изменения шаблона плана лечения.
 * @type {string}
 */
const EVENT_EDIT_TEMPLATE_NAME = 'on-edit-template';

/**
 * @description Название события удаления шаблона плана лечения.
 * @type {string}
 */
const EVENT_DELETE_TEMPLATE_NAME = 'on-delete-template';

export default {
  /**
   * @description Элемент шаблона плана лечения
   */
  name: 'TreatmentPlanTemplateItem',
  props: {
    template: {
      require: true,
      type: Object,
      default: () => {},
    },
  },
  methods: {
    /**
     * @description Отобразить диалог удаления
     * @param {Number} templateId
     */
    onShowDeleteDialog(templateId) {
      this.$emit(EVENT_DELETE_TEMPLATE_NAME, templateId);
    },
    /**
     * @description Редактировать выбранный шаблон.
     * @param template
     */
    onEditTemplate(template) {
      this.$emit(EVENT_EDIT_TEMPLATE_NAME, template);
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.treatment-plan-item {
  &__table {
    width: 100%;
    overflow-x: auto;

    &__head {
      padding-block: 14px;
      padding-inline: 10px 0;
      font-weight: 700;
      border-bottom: 2px solid #0489e0;
    }

    &__row {
      width: 100%;
      padding-inline: 10px 0;
      border-bottom: 1px solid #eaeff3;

      &:hover {
        background: #eaeff3;
      }
    }

    &:has(.row-name + span) {
      .treatment-plan-templates__table__head,
      .treatment-plan-templates__table__row {
        min-width: 750px;
      }
    }

    &__head,
    &__row {
      display: grid;
      grid-template-columns: 1fr 43px 43px;
      align-items: center;
      min-width: 400px;
      font-size: 14px;
      line-height: 17px;

      &__button-group {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        align-items: center;
        column-gap: 20px;
        padding-block: 12px;
      }

      &__name {
        text-align: left;
      }

      &__edit {
        @include buttons.btn-pen-edit(100%);
      }

      &__delete {
        @include buttons.btn-cross-remove(100%);
      }

    }

  }
}
</style>
